import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveSpeechLocale } from '../utils/speechLocale';

/**
 * Speech-recognition locale for the chat microphone: the active UI language decides
 * the spoken language; the browser locale only refines its regional variant.
 */
function useSpeechLang(): string {
  const { i18n } = useTranslation();
  const uiLanguage = i18n?.language;
  const browserLanguage = typeof navigator !== 'undefined' ? navigator.language : undefined;

  return useMemo(() => resolveSpeechLocale({ browserLanguage, uiLanguage }), [browserLanguage, uiLanguage]);
}

export default useSpeechLang;
